/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_SuccessInputs */

const en_claims_success = /** @type {(inputs: Claims_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your claim has been submitted successfully. We will contact you within 10 working days.`)
};

const fr_claims_success = /** @type {(inputs: Claims_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre réclamation a été soumise avec succès. Nous vous contacterons dans les 10 jours ouvrables.`)
};

/**
* | output |
* | --- |
* | "Your claim has been submitted successfully. We will contact you within 10 working days." |
*
* @param {Claims_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_success = /** @type {((inputs?: Claims_SuccessInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_SuccessInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_success(inputs)
	return fr_claims_success(inputs)
});